import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 623 323"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#4CA22E",
      "fill-rule": "evenodd",
      d: "M672 .594c-120.665 0-219.978 105.236-223.974 235.512v251.836C424.873 336.951 220.859 56.324.078.594L0 187.07C6.856 301.127 66.326 337.74 147.324 368.812c108.266 43.667 278.254 109.007 300.702 255.075-70.714-127.271-300.349-195.979-426.89-195.127 8.09 30.817 18.883 58.756 33.104 84.052 43.506 77.339 121.899 137.565 207.148 137.565h149.303c85.248 0 163.641-60.226 207.147-137.565 38.53-68.516 52.184-156.382 54.162-268.544V.594ZM336.039-80.623c51.537 0 93.319 45.457 93.319 101.527s-41.782 101.527-93.319 101.527c-51.537 0-93.319-45.457-93.319-101.527s41.782-101.527 93.319-101.527Z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }